import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { AuthContext, ContentContext } from '../../_context';
import { useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as MarcoFigurita } from '../../_assets/images/marco_figurita.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import { breakpoints } from '../../_helpers/breakpoints';
import { FaRankingStar } from "react-icons/fa6";
import { FiFileText } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { TbStarsFilled } from "react-icons/tb";

const SaveButtonContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 20px;
    z-index: 1000;
    
    &.slide-down {
        animation: slideDown 0.3s ease-out;
    }
    
    &.slide-up {
        animation: slideUp 0.3s ease-out forwards;
    }
    
    @keyframes slideDown {
        from {
            transform: translateY(-100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    
    @keyframes slideUp {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(-100%);
            opacity: 0;
        }
    }
    
    .save-button {
        background-color: #252e7c;
        color: white;
        border: none;
        padding: 12px 32px;
        border-radius: 25px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        box-shadow: 0px 4px 12px rgba(0,0,0,0.3);
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 10px;
        
        &:hover {
            background-color: #1a2260;
            transform: translateY(-2px);
            box-shadow: 0px 6px 16px rgba(0,0,0,0.4);
        }
        
        &:disabled {
            background-color: #999;
            cursor: not-allowed;
            transform: none;
        }
    }
`;

const RankingModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    padding: 20px;
`;

const RankingModalContent = styled.div`
    background-color: white;
    border-radius: 12px;
    max-width: 600px;
    width: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.3);
    
    .modal-header {
        background-color: #252e7c;
        color: white;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        h2 {
            margin: 0;
            font-family: 'argentina_2026_gombofontsRg';
            font-size: 28px;
        }
        
        .close-button {
            background: none;
            border: none;
            color: white;
            cursor: pointer;
            font-size: 32px;
            display: flex;
            align-items: center;
            padding: 0;
            transition: transform 0.2s;
            
            &:hover {
                transform: scale(1.1);
            }
        }
    }
    
    .user-stats {
        background-color: #98cef1;
        padding: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 2px solid #252e7c;
        
        .stat {
            text-align: center;
            
            .label {
                font-size: 14px;
                color: #252e7c;
                margin-bottom: 5px;
            }
            
            .value {
                font-family: 'argentina_2026_gombofontsRg';
                font-size: 32px;
                color: #252e7c;
            }
        }
    }
    
    .ranking-list {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        
        .ranking-item {
            display: flex;
            align-items: center;
            padding: 12px;
            border-bottom: 1px solid #e0e0e0;
            transition: background-color 0.2s;
            
            &:hover {
                background-color: #f5f5f5;
            }
            
            &.current-user {
                background-color: #98cef1;
                font-weight: bold;
            }
            
            .position {
                width: 30px;
                font-family: 'argentina_2026_gombofontsRg';
                font-size: 18px;
                line-height: 18px;
                color: #252e7c;
                text-align: center;
            }
            
            .name {
                flex: 1;
                font-size: 14px;
                color: #333;
                padding: 0 10px;
            }
            
            .points {
                font-family: 'argentina_2026_gombofontsRg';
                font-size: 18px;
                line-height: 18px;
                color: #252e7c;
                min-width: 60px;
                text-align: right;
            }
        }
    }
    
    .loading {
        padding: 40px;
        text-align: center;
        color: #666;
    }

    @media ${breakpoints.xs} {
        .ranking-list {
            padding: 20px;
            .ranking-item {
                padding: 12px;
                .position {
                    width: 50px;
                    font-size: 24px;
                    line-height: 24px;
                }
                .name {
                    font-size: 16px;
                    padding: 0 15px;
                }
                .points {
                    font-size: 22px;
                    line-height: 22px;
                    min-width: 60px;
                }
            }
        }
    }
    @media ${breakpoints.sm} {
    }
    @media ${breakpoints.md} {
    }
    @media ${breakpoints.lg} {
    }
    @media ${breakpoints.xxl} {
    }
    @media ${breakpoints.xxxl} {
    }
    @media ${breakpoints.xxxxl} {
    }
`;

const MecanicaModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    padding: 20px;
`;

const MecanicaModalContent = styled.div`
    background-color: white;
    border-radius: 12px;
    max-width: 700px;
    width: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.3);
    
    .modal-header {
        background-color: #252e7c;
        color: white;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        h2 {
            margin: 0;
            font-family: 'argentina_2026_gombofontsRg';
            font-size: 28px;
        }
        
        .close-button {
            background: none;
            border: none;
            color: white;
            cursor: pointer;
            font-size: 32px;
            display: flex;
            align-items: center;
            padding: 0;
            transition: transform 0.2s;
            
            &:hover {
                transform: scale(1.1);
            }
        }
    }
    
    .modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 30px;
        
        h3 {
            font-family: 'argentina_2026_gombofontsRg';
            font-size: 22px;
            color: #252e7c;
            margin-top: 0;
            margin-bottom: 15px;
        }
        
        p {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
            margin-bottom: 15px;
        }
        
        ul {
            margin-left: 20px;
            margin-bottom: 15px;
            
            li {
                font-size: 16px;
                line-height: 1.6;
                color: #333;
                margin-bottom: 8px;
            }
        }
    }

    @media ${breakpoints.xs} {
        .modal-body {
            padding: 20px;
            
            h3 {
                font-size: 20px;
            }
            
            p, ul li {
                font-size: 14px;
            }
        }
    }
`;

const EventEndedModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000;
    padding: 20px;
`;

const EventEndedModalContent = styled.div`
    /* background: linear-gradient(135deg, #252e7c 0%, #1a2260 100%); */
    /* background-color: #252e7c; */
    background: linear-gradient(0deg,rgba(255, 255, 255, 1) 65%, rgba(152, 206, 241, 1) 90%);
    border-radius: 16px;
    max-width: 650px;
    width: 100%;
    padding: 40px 30px;
    box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.5);
    text-align: center;
    /* border: 3px solid #f1c92a; */
    border: 3px solid #98cef1;
    
    .icon-container {
        display: flex;
        justify-content: center;
        font-size: 60px;
        color: #252e7c;
        margin-bottom: 20px;
        animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
    }
    
    h2 {
        margin: 0 0 20px 0;
        font-family: 'argentina_2026_gombofontsRg';
        font-size: 32px;
        color: #252e7c;
        text-transform: uppercase;
    }
    
    p {
        font-size: 18px;
        line-height: 1.6;
        color: #252e7c;
        margin-bottom: 30px;
    }
    
    .close-button {
        background-color: #98cef1;
        color: #252e7c;
        border: none;
        padding: 15px 40px;
        border-radius: 30px;
        font-size: 18px;
        font-weight: bold;
        font-family: 'argentina_2026_gombofontsRg';
        cursor: pointer;
        transition: all 0.3s ease;
        /* box-shadow: 0px 4px 12px rgba(241, 201, 42, 0.4); */
        
        &:hover {
            background-color: #252e7c;
            transform: translateY(-2px);
            color: #FFFFFF;
            /* box-shadow: 0px 6px 16px rgba(241, 201, 42, 0.6); */
        }
    }
    
    @media ${breakpoints.xs} {
        padding: 30px 20px;
        
        .icon-container {
            font-size: 50px;
        }
        
        h2 {
            font-size: 26px;
        }
        
        p {
            font-size: 16px;
        }
    }
`;

const WrappedStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    &.from_outside{
        background: linear-gradient(0deg,rgba(255, 255, 255, 1) 65%, rgba(152, 206, 241, 1) 90%)
    }
    h1{
        font-family: 'argentina_2026_gombofontsRg';
    }
    p{
        margin: 0;
        padding: 0;
    }
    .box_close_ok{
        width: 100%;
        padding-top: 15px;
        padding-bottom: 15px;
        //background: linear-gradient(to right, #bf953f, #fcf6ba, #b38728, #fbf5b7, #aa771c);
        background: linear-gradient(0deg, #f1c92a 15%, #bf953f 95%);
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-left: 20px;
        padding-right: 20px;
        border-bottom: 1px solid #252e7c;
        .icon{
            font-size: 30px;
            line-height: 30px;
        }
        >p{
            padding-top: 5px;
            font-size: 30px;
            line-height: 35px;
            color: #252e7c;
            font-family: 'argentina_2026_gombofontsRg';
            margin-left: 10px;
        }
    }
    .box_close{
        width: 100%;
        padding-top: 15px;
        padding-bottom: 15px;
        background-color: #252e7c;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        >p{
            font-size: 14px;
            line-height: 18px;
            color: #FFFFFF;
            margin-bottom: 10px;
            padding-left: 20px;
            padding-right: 20px;
        }
        button{
            font-family: 'argentina_2026_gombofontsRg';
            background-color: #FFFFFF;
            color: #252e7c;
            border: none;
            padding: 10px 15px 10px 13px;
            border-radius: 6px;
            font-size: 26px;
            line-height: 26px;
            font-weight: bold;
            cursor: pointer;
            /* box-shadow: 0px 4px 12px rgba(0,0,0,0.3); */
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 10px;
            p{
                margin: 0;
                padding: 0;
            }
            .icon{
                font-size: 25px;
                svg{
                    display: flex;
                }
            }
            &:hover {
                color: #FFFFFF;
                background-color: #1a2260;
                transform: translateY(-2px);
                box-shadow: 0 0 8px rgba(0,0,0,0.4);
            }
            
            &:disabled {
                background-color: #999;
                cursor: not-allowed;
                transform: none;
            }
        }
    }
    .box_opciones{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 100%;
        border-top: 1px solid #252e7c;
        border-bottom: 1px solid #252e7c;
        /* margin-bottom: 30px; */
        padding-bottom: 10px;
        padding-top: 10px;
        button{
            display: flex;
            flex-direction: row;
            justify-content: center;
            width: 80%;
            background-color: #252e7c;
            color: white;
            border: none;
            padding: 10px 15px 10px 13px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            /* box-shadow: 0px 4px 12px rgba(0,0,0,0.3); */
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 10px;
            p{
                margin: 0;
                padding: 0;
            }
            .icon{
                font-size: 25px;
                svg{
                    display: flex;
                }
            }
            &:hover {
                background-color: #1a2260;
                transform: translateY(-2px);
                box-shadow: 0 0 8px rgba(0,0,0,0.4);
            }
            
            &:disabled {
                background-color: #999;
                cursor: not-allowed;
                transform: none;
            }
        }
        @media ${breakpoints.xs} {
            flex-direction: row;
            button{
                width: auto;
            }
        }
    }
    .box_tuseleccion{
        width: 100%;
        
        margin-bottom: 10px;
        
        .title{
            font-family: 'argentina_2026_gombofontsRg';
            width: 100%;
            p{
                font-size: 75px;
                line-height: 75px;
                width: 100%;
                padding: 10px 20px;
                color: #FFFFFF;
                text-shadow: 2px 2px #000000;
                
            }
        }
        .description{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            color: #FFFFFF;
            font-size: 16px;
            line-height: 20px;
            background-color: #252e7c;
            padding: 13px 20px;
        }
        .counter{
            font-size: 125px;
            line-height: 125px;
            font-family: 'argentina_2026_gombofontsRg';
            color: #252e7c;
            padding-top: 10px;
            padding-bottom: 10px;
            .selected_color{
                color: #FFFFFF;
            }
        }
        .points_counter{
            display: flex;
            flex-direction: column;
            font-family: 'argentina_2026_gombofontsRg';
            font-size: 120px;
            line-height: 120px;
            width: 100%;
            padding: 10px 20px;
            color: #FFFFFF;
            
            /* text-shadow: 2px 2px #000000; */
            .title{
                font-size: 40px;
                line-height: 40px;
                color: #252e7c;
            }
        }
    }
    .position-group {
        width: 293px;
        margin-top: 30px;
        
        .position-title {
            font-family: 'argentina_2026_gombofontsRg';
            font-size: 30px;
            color: #252e7c;
            margin-bottom: 10px;
            text-align: left;
            width: 100%;
        }
    }
    
    .cards{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        .card{
            position: relative;
            background-color: transparent;
            width: 141px;
            height: 186px;

            border-radius: 8px;
            overflow: hidden;

            box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);
            -webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);
            -moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);
            .name{
                font-family: 'argentina_2026_gombofontsRg';
                position: absolute;
                width: 100%;
                text-align: center;
                line-height: 16px;
                font-size: 16px;
                bottom: 6px;
                z-index: 5;
                color: #252e7c;
            }
            .number{
                font-family: 'argentina_2026_gombofontsRg';
                position: absolute;
                text-align: center;
                width: 20px;
                top: 7px;
                left: 4px;
                font-size: 16px;
                line-height: 16px;
                /* background-color: red; */
                z-index: 5;
                color: #252e7c;
            }
            .picture{
                position: absolute;
                top:0px;
                left: 0px;
                overflow: hidden;
                z-index: 1;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    filter: grayscale(100%);
                }
                z-index: 3;
            }
            .marco-figurita{
                position: absolute;
                /* fill: #ecdd00; */
                fill: #FFFFFF;
                width: 100%;
                height: auto;
                

                

                
                z-index: 5;
                svg{
                    display: flex;
                }
            }
            .pointing-hand{
                display: flex;
                align-self: center;
                position: absolute;
                width: 70px;
                bottom: 29px;
                background-color: #252e7c;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                box-shadow: 0px 0px 15px 6px rgb(190, 194, 239);
                -webkit-box-shadow: 0px 0px 15px 6px rgb(190, 194, 239);
                -moz-box-shadow: 0px 0px 15px 6px rgb(190, 194, 239);
                img{
                    width: 100%;
                    float: left;
                }
                z-index: 4;
            }
            &:hover{
                cursor: pointer;
                .marco-figurita{
                    fill: #98cef1;
                }
                .picture{
                    img{
                        filter: grayscale(0%);
                    }
                }
                
            }
            &.is_selected{
                .marco-figurita{
                    fill: #98cef1;
                }
                .picture{
                    img{
                        filter: grayscale(0%);
                    }
                }
            }
            &.is_disabled{
                cursor: not-allowed;
                opacity: 0.5;
                
                &:hover{
                    .marco-figurita{
                        fill: #FFFFFF;
                    }
                    .picture{
                        img{
                            filter: grayscale(100%);
                        }
                    }
                }
            }
            &.is_blocked{
                opacity: 1!important;
            }
            &:hover.is_blocked{
                .marco-figurita{
                    fill: #98cef1;
                }
                .picture{
                    img{
                        filter: grayscale(0%);
                    }
                }
            }
            &.is_winner{
                cursor: default;
                .marco-figurita{
                    fill: #98cef1!important;
                }
                .picture{
                    img{
                        filter: grayscale(0%)!important;
                    }
                }
            }
            &.is_pointing{
                .marco-figurita{}
            }
            &.is_closed{
                cursor: default!important;
            }
            &:hover.is_closed{
                .marco-figurita{
                    fill: #ffffff;
                }
                .picture{
                    img{
                        filter: grayscale(100%);
                    }
                }
            }
            &:hover.is_closed.is_selected{
                .marco-figurita{
                    fill: #98cef1;
                }
                .picture{
                    img{
                        filter: grayscale(0%);
                    }
                }
            }
        }
    }
    @media ${breakpoints.xs} {
        .position-group{
            width: 443px;
        }
        .cards{
            gap: 10px;
            .card{
                width: 141px;
                height: 186px;
                .name{
                    line-height: 16px;
                    font-size: 16px;
                    bottom: 6px;
                }
                .number{
                    width: 20px;
                    top: 7px;
                    left: 4px;
                    font-size: 16px;
                    line-height: 16px;
                }
                .picture{
                    top:0px;
                    left: 0px;
                }
                .marco-figurita{
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
    @media ${breakpoints.sm} {
        .position-group{
            width: 594px;
        }
    }
    @media ${breakpoints.md} {
        .position-group{
            width: 896px;
        }
    }
    @media ${breakpoints.lg} {
        .position-group{
            width: 1047px;
        }
    }
    @media ${breakpoints.xxl} {
        .position-group{
            width: 1350px;
        }
    }
    @media ${breakpoints.xxxl} {
        .position-group{
            width: 1500px;
        }
    }
    @media ${breakpoints.xxxxl} {
        .position-group{
            width: 1802px;
        }
    }
    /*
    export const breakpoints = {
    xs: (min-width: 576px)
    sm: (min-width: 768px)
    md: (min-width: 992px)
    lg: (min-width: 1200px)
    xl: (min-width: 1366px)
    xxl: (min-width: 1440px)
    xxxl: (min-width: 1680px)
    xxxxl: (min-width: 1920px)
}
    */
`

const ListaMundialContainer = () => {

    const { isAuth } = useContext(AuthContext);
    const { userData } = useContext(ContentContext);

    const [selectedIds, setSelectedIds] = useState([]);
    const [originalIds, setOriginalIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showRankingModal, setShowRankingModal] = useState(false);
    const [showMecanicaModal, setShowMecanicaModal] = useState(false);
    const [showEventEndedModal, setShowEventEndedModal] = useState(false);
    const [rankingData, setRankingData] = useState(null);
    const [isLoadingRanking, setIsLoadingRanking] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [accessDenied, setAccessDenied] = useState(false);
    const [ uid, setUid ] = useState(null);
    const { search, pathname } = useLocation();
    const [notUid, setNotUid] = useState(false);
    const [eventClosed, setEventClosed] = useState(false);
    const [enventEnded, setEventEnded] = useState(false);
    const [listaGanadora, setListaGanadora] = useState(null);

    //const route = 'http://localhost:8888/protagonistas_mundial2026_seleccion';
    const route = 'https://fabianhr.com/protagonistas/lista_mundial2026';

    useEffect(() => {
        console.log("pathname", pathname)
        if(pathname){
            if(pathname == '/lista-mundial' || pathname == '/lista-mundial/'){
                if(search.length > 0) {
                    const query = new URLSearchParams(search);
                    if(query.get("uid") && query.get("uid").length > 0){
                        setUid(query.get("uid"));
                    }
                }else{
                    setNotUid(true);
                    setIsLoadingData(true);
                }
            }
        }
        return () => {}

    }, [pathname, isAuth])

    useEffect(() => {
        if(isAuth && userData){
            setUid(userData.dni);
        }
        return () => {}

    }, [isAuth, userData])

    useEffect(() => {
      if(notUid && !isAuth && !userData){
        setIsLoadingData(false);
        setAccessDenied(true);
      }
    
      return () => {}
    }, [notUid, isAuth, userData])
    

    useEffect(() => {
        const fetchLista = async () => {
            setIsLoadingData(true);
            setAccessDenied(false);
            try {
                const formData = new FormData();
                formData.append('uid', uid);
                
                const response = await axios.post(
                    `${route}/get_lista.php`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                console.log("response", response.data.lista_ganadora, response.status !== 200)
                if (response.status !== 200) {
                    setAccessDenied(true);
                    return;
                }
                
                if (response.data && response.data.lista && response.data.lista.cards) {
                    console.log('Respuesta del servidor:', response.data);
                    const cardsArray = typeof response.data.lista.cards === 'string' 
                        ? JSON.parse(response.data.lista.cards) 
                        : response.data.lista.cards;
                    setSelectedIds(cardsArray);
                    setOriginalIds(cardsArray);
                    setEventClosed(response?.data?.lista?.closed);
                    console.log("🔥", response)
                    // Capturar lista_ganadora si existe
                    
                }
                // Capturar is_close si existe
                if (response.data && response.data.is_close !== undefined) {
                    setEventEnded(response.data.is_close);
                }
                if (response.data.lista_ganadora !== undefined) {
                    const listaGanadoraArray = response.data.lista_ganadora === null 
                        ? null 
                        : (typeof response.data.lista_ganadora === 'string' 
                            ? JSON.parse(response.data.lista_ganadora) 
                            : response.data.lista_ganadora);
                    
                    setListaGanadora(listaGanadoraArray);
                    console.log('Lista ganadora:', listaGanadoraArray);
                }
            } catch (error) {
                console.error('Error al obtener la lista:', error);
                if (error.response && error.response.status !== 200) {
                    setAccessDenied(true);
                }
            } finally {
                setIsLoadingData(false);
            }
        };

        if (uid) {
            fetchLista();
        }
        // No ponemos isLoadingData en false aquí, esperamos a que llegue el uid
    }, [uid]);

// useEffect(() => {
//   console.log("🍑", accessDenied)

//   return () => {}
// }, [accessDenied])

    useEffect(() => {
        if (enventEnded === true) {
            setShowEventEndedModal(true);
        }
    }, [enventEnded]);

    const figuritas = [
        {id: 1, name: "Walter Benítez", number: 1, image: require('../../_assets/images/figuritas/walter_benitez.jpg'), position: "Arqueros"},
        {id: 2, name: "Emiliano Martinez", number: 23, image: require('../../_assets/images/figuritas/emiliano_martinez.jpg'), position: "Arqueros"},
        {id: 3, name: "Geronimo Rulli", number: 1, image: require('../../_assets/images/figuritas/geronimo_rulli.jpg'), position: "Arqueros"},
        {id: 4, name: "Juan Musso", number: 1, image: require('../../_assets/images/figuritas/juan_musso.jpg'), position: "Arqueros"},
        {id: 5, name: "Facundo Cambeses", number: 25, image: require('../../_assets/images/figuritas/facundo_cambeses.jpg'), position: "Arqueros"},
        {id: 6, name: "Santiago Beltran", number: 41, image: require('../../_assets/images/figuritas/santiago_beltran.jpg'), position: "Arqueros"},
        {id: 7, name: "Nicolás Capaldo", number: 24, image: require('../../_assets/images/figuritas/nicolas_capaldo.jpg'), position: "Defensores"},
        {id: 8, name: "Nahuel Molina", number: 26, image: require('../../_assets/images/figuritas/nahuel_molina.jpg'), position: "Defensores"},
        {id: 9, name: "Gonzalo Montiel", number: 4, image: require('../../_assets/images/figuritas/gonzalo_montiel.jpg'), position: "Defensores"},
        {id: 10, name: "Cristian Romero", number: 13, image: require('../../_assets/images/figuritas/cristian_romero.jpg'), position: "Defensores"},
        {id: 11, name: "Nicolás Otamendi", number: 19, image: require('../../_assets/images/figuritas/nicolas_otamendi.jpg'), position: "Defensores"},
        {id: 12, name: "Lisandro Martínez", number: 25, image: require('../../_assets/images/figuritas/lisandro_martinez.jpg'), position: "Defensores"},
        {id: 13, name: "Marcos Acuña", number: 8, image: require('../../_assets/images/figuritas/marcos_acuna.jpg'), position: "Defensores"},
        {id: 14, name: "Germán Pezzella", number: 6, image: require('../../_assets/images/figuritas/german_pezzella.jpg'), position: "Defensores"},
        {id: 15, name: "Lautaro Di Lollo", number: 2, image: require('../../_assets/images/figuritas/lautaro_dilollo.jpg'), position: "Defensores"},
        {id: 16, name: "Marcos Senesi", number: 5, image: require('../../_assets/images/figuritas/marcos_senesi.jpg'), position: "Defensores"},
        {id: 17, name: "Facundo Medina", number: 14, image: require('../../_assets/images/figuritas/facundo_medina.jpg'), position: "Defensores"},
        {id: 18, name: "Zaid Romero", number: 24, image: require('../../_assets/images/figuritas/zaid_romero.jpg'), position: "Defensores"},
        {id: 19, name: "Gabriel Rojas", number: 13, image: require('../../_assets/images/figuritas/gabriel_rojas.jpg'), position: "Defensores"},
        {id: 20, name: "L. Martínez Quarta", number: 2, image: require('../../_assets/images/figuritas/lucas_martinez_quarta.jpg'), position: "Defensores"},
        {id: 21, name: "Agustín Giay", number: 4, image: require('../../_assets/images/figuritas/agustin_giay.jpg'), position: "Defensores"},
        {id: 22, name: "Kevin Mac Allister", number: 5, image: require('../../_assets/images/figuritas/kevin_mac_allister.jpg'), position: "Defensores"},
        {id: 23, name: "Guido Rodríguez", number: 18, image: require('../../_assets/images/figuritas/guido_rodriguez.jpg'), position: "Defensores"},
        //{id: 23, name: "Tomás Palacios", number: 16, image: require('../../_assets/images/figuritas/tomas_palacios.jpg'), position: "Defensores"},
        //{id: 24, name: "Julio Soler", number: 3, image: require('../../_assets/images/figuritas/julio_soler.jpg'), position: "Defensores"},
        {id: 25, name: "Nicolás Tagliafico", number: 3, image: require('../../_assets/images/figuritas/nicolas_tagliafico.jpg'), position: "Defensores"},
        {id: 26, name: "Leonardo Balerdi", number: 6, image: require('../../_assets/images/figuritas/leonardo_balerdi.jpg'), position: "Defensores"},
        {id: 27, name: "Máximo Perrone", number: 6, image: require('../../_assets/images/figuritas/maximo_perrone.jpg'), position: "Mediocampistas"},
        {id: 28, name: "Milton Delgado", number: 43, image: require('../../_assets/images/figuritas/milton_delgado.jpg'), position: "Mediocampistas"},
        {id: 29, name: "Nicolás Domínguez", number: 17, image: require('../../_assets/images/figuritas/nicolas_dominguez.jpg'), position: "Mediocampistas"},
        {id: 30, name: "Leandro Paredes", number: 5, image: require('../../_assets/images/figuritas/leandro_paredes.jpg'), position: "Mediocampistas"},
        {id: 31, name: "Alexis Mac Allister", number: 20, image: require('../../_assets/images/figuritas/alexis_mac_allister.jpg'), position: "Mediocampistas"},
        {id: 32, name: "Enzo Fernández", number: 24, image: require('../../_assets/images/figuritas/enzo_fernandez.jpg'), position: "Mediocampistas"},
        {id: 33, name: "Thiago Almada", number: 11, image: require('../../_assets/images/figuritas/thiago_almada.jpg'), position: "Mediocampistas"},
        {id: 34, name: "Rodrigo De Paul", number: 7, image: require('../../_assets/images/figuritas/rodrigo_de_paul.jpg'), position: "Mediocampistas"},
        {id: 35, name: "Nicolás González", number: 15, image: require('../../_assets/images/figuritas/nicolas_gonzalez.jpg'), position: "Mediocampistas"},
        {id: 36, name: "Exequiel Palacios", number: 14, image: require('../../_assets/images/figuritas/exequiel_palacios.jpg'), position: "Mediocampistas"},
        {id: 37, name: "Giuliano Simeone", number: 17, image: require('../../_assets/images/figuritas/giuliano_simeone.jpg'), position: "Mediocampistas"},
        {id: 38, name: "Valentín Barco", number: 6, image: require('../../_assets/images/figuritas/valentin_barco.jpg'), position: "Mediocampistas"},
        {id: 39, name: "Nicolás Paz", number: 20, image: require('../../_assets/images/figuritas/nicolas_paz.jpg'), position: "Mediocampistas"},
        {id: 40, name: "Alan Varela", number: 5, image: require('../../_assets/images/figuritas/alan_varela.jpg'), position: "Mediocampistas"},
        {id: 41, name: "Ezequiel Fernández", number: 21, image: require('../../_assets/images/figuritas/ezequiel_fernandez.jpg'), position: "Mediocampistas"},
        {id: 42, name: "Aníbal Moreno", number: 14, image: require('../../_assets/images/figuritas/anibal_moreno.jpg'), position: "Mediocampistas"},
        {id: 43, name: "Tomás Aranda", number: 10, image: require('../../_assets/images/figuritas/tomas_aranda.jpg'), position: "Mediocampistas"},
        {id: 44, name: "Emiliano Buendía", number: 7, image: require('../../_assets/images/figuritas/emiliano_buendia.jpg'), position: "Mediocampistas"},
        {id: 45, name: "Giovanni Lo Celso", number: 16, image: require('../../_assets/images/figuritas/giovanni_lo_celso.jpg'), position: "Mediocampistas"},
        {id: 46, name: "Lionel Messi", number: 10, image: require('../../_assets/images/figuritas/lionel_messi.jpg'), position: "Delanteros"},
        {id: 47, name: "Franco Mastantuono", number: 21, image: require('../../_assets/images/figuritas/franco_mastantuono.jpg'), position: "Delanteros"},
        {id: 48, name: "Mateo Pellegrino", number: 32, image: require('../../_assets/images/figuritas/mateo_pellegrino.jpg'), position: "Delanteros"},
        {id: 49, name: "Gianluca Prestianni", number: 20, image: require('../../_assets/images/figuritas/gianluca_prestianni.jpg'), position: "Delanteros"},
        {id: 50, name: "Claudio Echeverri", number: 10, image: require('../../_assets/images/figuritas/claudio_echeverri.jpg'), position: "Delanteros"},
        //{id: 51, name: "Joaquín Panichelli", number: 9, image: require('../../_assets/images/figuritas/joaquin_panichelli.jpg'), position: "Delanteros"},
        {id: 52, name: "Matías Soulé", number: 11, image: require('../../_assets/images/figuritas/matias_soule.jpg'), position: "Delanteros"},
        {id: 53, name: "Lautaro Martínez", number: 22, image: require('../../_assets/images/figuritas/lautaro_martinez.jpg'), position: "Delanteros"},
        {id: 54, name: "José López", number: 16, image: require('../../_assets/images/figuritas/jose_lopez.jpg'), position: "Delanteros"},
        {id: 55, name: "Julián Álvarez", number: 9, image: require('../../_assets/images/figuritas/julian_alvarez.jpg'), position: "Delanteros"},
        //{id: 56, name: "Paulo Dybala", number: 10, image: require('../../_assets/images/figuritas/paulo_dybala.jpg'), position: "Delanteros"},
        {id: 57, name: "Alejandro Garnacho", number: 17, image: require('../../_assets/images/figuritas/alejandro_garnacho.jpg'), position: "Delanteros"},
        //{id: 58, name: "Ángel Correa", number: 15, image: require('../../_assets/images/figuritas/angel_correa.jpg'), position: "Delanteros"},
        {id: 59, name: "Santiago Castro", number: 21, image: require('../../_assets/images/figuritas/santiago_castro.jpg'), position: "Delanteros"},
        //{id: 60, name: "V. Castellanos", number: 16, image: require('../../_assets/images/figuritas/v_castellanos.jpg'), position: "Delanteros"}
    ];

    const handleReglamento = () => {
        window.open('pdfs/Reglamento_CONCURSO_ACERTA_LA_LISTA_1305_2026_.pdf', '_blank').focus();
    }

    const handleCardClick = (id) => {
        // Si el evento está cerrado, no permitir cambios
        if (eventClosed) {
            return;
        }
        
        setSelectedIds(prevIds => {
            if (prevIds.includes(id)) {
                // Si el id ya está en el array, lo removemos
                return prevIds.filter(selectedId => selectedId !== id);
            } else {
                // Si ya hay 26 seleccionados, no permitir agregar más
                if (prevIds.length >= 26) {
                    return prevIds;
                }
                // Si el id no está en el array, lo agregamos
                return [...prevIds, id];
            }
        });
    };

    const groupByPosition = () => {
        const positionOrder = ['Arqueros', 'Defensores', 'Mediocampistas', 'Delanteros'];
        
        // Filtrar figuritas si existe lista_ganadora y no es null
        const figuritasToShow = listaGanadora !== null 
            ? figuritas.filter(figurita => listaGanadora.includes(figurita.id))
            : figuritas;
        
        const grouped = figuritasToShow.reduce((acc, figurita) => {
            if (!acc[figurita.position]) {
                acc[figurita.position] = [];
            }
            acc[figurita.position].push(figurita);
            return acc;
        }, {});
        
        return positionOrder
            .filter(position => grouped[position])
            .map(position => ({
                position,
                figuritas: grouped[position]
            }));
    };

    const hasChanges = () => {
        if (selectedIds.length !== originalIds.length) return true;
        const sortedSelected = [...selectedIds].sort((a, b) => a - b);
        const sortedOriginal = [...originalIds].sort((a, b) => a - b);
        return JSON.stringify(sortedSelected) !== JSON.stringify(sortedOriginal);
    };

    const handleSave = async (isFinalSubmit = false) => {
        setIsSaving(true);
        try {
            const formData = new FormData();
            formData.append('uid', uid);
            formData.append('cards', JSON.stringify(selectedIds));
            console.log("isFinalSubmit", isFinalSubmit)
            // Si es envío final, agregar el campo closed
            if (isFinalSubmit) {
                formData.append('closed', 'true');
            }
            
            const response = await axios.post(
                `${route}/set_lista.php`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            
            if (response.status === 200) {
                setIsSaving(false);
                setShowSuccess(true);
                console.log('Lista guardada exitosamente');
                
                // Si es envío final, actualizar el estado eventClosed
                if (isFinalSubmit) {
                    setEventClosed(true);
                }
                
                // Esperar 3 segundos, actualizar originalIds y luego ocultar
                setTimeout(() => {
                    setOriginalIds(selectedIds);
                }, 2000);
                
                // Ocultar mensaje después de 2.3 segundos (2s visible + 0.3s animación)
                setTimeout(() => {
                    setShowSuccess(false);
                }, 2300);
            }
        } catch (error) {
            console.error('Error al guardar la lista:', error);
            setIsSaving(false);
        }
    };

    const handleFinalSubmit = async () => {
        await handleSave(true);
    };

    const fetchRanking = async () => {
        console.log("fetchRanking");
        setIsLoadingRanking(true);
        try {
            const formData = new FormData();
            formData.append('uid', uid);
            
            const response = await axios.post(
                `${route}/get_ranking.php`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            
            if (response.status !== 200) {
                setAccessDenied(true);
                setShowRankingModal(false);
                return;
            }
            
            console.log("🥕", response.data.ranking)
            if (response.data) {
                setRankingData(response.data);
            }
        } catch (error) {
            console.error('Error al obtener el ranking:', error);
            if (error.response && error.response.status !== 200) {
                setAccessDenied(true);
                setShowRankingModal(false);
            }
        } finally {
            setIsLoadingRanking(false);
        }
    };

    const handleOpenRanking = () => {
        setShowRankingModal(true);
        fetchRanking();
    };

    const handleCloseRanking = () => {
        setShowRankingModal(false);
    };

    const handleOpenMecanica = () => {
        setShowMecanicaModal(true);
    };

    const handleCloseMecanica = () => {
        setShowMecanicaModal(false);
    };

    const handleCloseEventEnded = () => {
        setShowEventEndedModal(false);
    };

    if (isLoadingData) {
        return (
            <WrappedStyled
                className={(isAuth === null || isAuth === false) ? "from_outside" : ""}
            >
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    gap: '20px'
                }}>
                    <CircularProgress size={60} style={{ color: '#252e7c' }} />
                    <p style={{ fontSize: '18px', color: '#252e7c', fontWeight: 'bold' }}>Cargando datos...</p>
                </div>
            </WrappedStyled>
        );
    }

    if (accessDenied) {
        return (
            <WrappedStyled
                className={(isAuth === null || isAuth === false) ? "from_outside" : ""}
            >
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    gap: '20px',
                    padding: '20px'
                }}>
                    <div style={{
                        backgroundColor: '#ffebee',
                        border: '2px solid #ef5350',
                        borderRadius: '12px',
                        padding: '30px',
                        maxWidth: '500px',
                        textAlign: 'center'
                    }}>
                        <h2 style={{ 
                            fontSize: '32px', 
                            color: '#c62828', 
                            fontWeight: 'bold',
                            marginBottom: '15px',
                            fontFamily: 'argentina_2026_gombofontsRg'
                        }}>
                            Acceso No Permitido
                        </h2>
                        <p style={{ 
                            fontSize: '18px', 
                            color: '#d32f2f',
                            margin: '0'
                        }}>
                            No tenés permiso para acceder a este contenido.
                        </p>
                    </div>
                </div>
            </WrappedStyled>
        );
    }

    return (
        <>
            {!eventClosed && (hasChanges() || showSuccess) && (
                <SaveButtonContainer className={showSuccess && !hasChanges() ? 'slide-up' : 'slide-down'}>
                    <button 
                        className="save-button" 
                        onClick={() => handleSave(false)}
                        disabled={isSaving || showSuccess}
                    >
                        {isSaving ? (
                            <>
                                <CircularProgress size={20} style={{ color: 'white' }} />
                                <span>Guardando...</span>
                            </>
                        ) : showSuccess ? (
                            'Se guardó con éxito'
                        ) : (
                            'Guardar selección'
                        )}
                    </button>
                </SaveButtonContainer>
            )}
            <WrappedStyled
                className={`${(isAuth === null || isAuth === false) ? "from_outside" : ""} ${enventEnded ? "is_closed" : ""}`}
            >
                <div className='box_tuseleccion'>
                    <div className='title'>
                        <p>Acertá la lista</p>
                    </div>
                    <div className='description'>
                        <p>Elegí a los 26 convocados que creés que llegarán al Mundial 2026 y sumá puntos con cada jugador que aciertes en la lista final.</p>
                    </div>
                    {listaGanadora !== null && (() => {
                        const aciertos = selectedIds.filter(id => listaGanadora.includes(id)).length;
                        return (
                            <div className='points_counter'>
                                <span className='title'>Tus puntos</span>
                                <span className='total'>{aciertos}</span>
                            </div>
                        );
                    })()}
                    {listaGanadora === null && (
                    <div className='counter'>
                        <span className='selected_color'>{selectedIds.length}</span>
                        <span>/</span>
                        <span>26</span>
                    </div>
                    )}
                </div>
                
                <div className='box_opciones'>
                    <button onClick={handleOpenMecanica}>
                        <div className='icon'><FiFileText /></div>
                        <p>Mecánica</p>
                    </button>
                    <button onClick={() => handleReglamento()}>
                        <div className='icon'><FiFileText /></div>
                        <p>Reglamento</p>
                    </button>
                    <button onClick={handleOpenRanking} disabled={false}>
                        <div className='icon'><FaRankingStar /></div>
                        <p>Ranking</p>
                    </button>
                </div>

                {!eventClosed && selectedIds.length === 26 && (
                <div className='box_close'>
                    <p>Si ya seleccionaste a tus 26 jugadores, no olvides enviar tu lista final hasta el 25 de mayo inclusive.</p>
                    <button onClick={handleFinalSubmit} disabled={isSaving}>
                        <div className='icon'><TbStarsFilled /></div>
                        <p>ENVIÁ TU LISTA FINAL</p>
                    </button>
                </div>
                )}
                {eventClosed && (
                <div className='box_close_ok'>
                    <div className='icon'><TbStarsFilled /></div>
                    <p>Tu lista fue enviada con éxito</p>
                </div>
                )}

                {/* <div style={{ marginBottom: '20px', padding: '10px', background: '#f0f0f0', borderRadius: '5px' }}>
                    <strong>IDs seleccionados:</strong> {selectedIds.length > 0 ? selectedIds.join(', ') : 'Ninguno'}
                </div> */}
                {groupByPosition().map(({ position, figuritas: positionFiguritas }) => (
                    <div key={position} className='position-group'>
                        <h2 className='position-title'>{position}</h2>
                        <div className='cards'>
                            {positionFiguritas.map((figurita) => {
                                const isSelected = selectedIds.includes(figurita.id);
                                const isDisabled = eventClosed || (!isSelected && selectedIds.length >= 26);
                                const isWinner = listaGanadora !== null && listaGanadora.includes(figurita.id);
                                const isPointing = isSelected && isWinner;
                                
                                return (
                                    <div 
                                        className={`card ${
                                            isSelected ? 'is_selected' : ''
                                        } ${
                                            isDisabled ? 'is_disabled' : ''
                                        } ${
                                            isSelected && isDisabled ? 'is_blocked' : ''
                                        } ${
                                            isWinner ? 'is_winner' : ''
                                        } ${
                                            isPointing ? 'is_pointing' : ''
                                        } ${
                                            enventEnded ? 'is_closed' : ''
                                        }`}
                                        key={figurita.id}
                                        id={figurita.id}
                                        onClick={() => !enventEnded && handleCardClick(figurita.id)}
                                    >
                                        <MarcoFigurita className="marco-figurita" />
                                        {isPointing && (
                                            <div className="pointing-hand">
                                                <img src={require('../../_assets/images/pointing_hand.svg')} alt="Mano señalando" />
                                            </div>
                                        )}
                                        {/* <div className=''>as</div> */}
                                        <div className='picture'>
                                            <img src={figurita.image} alt={`Imagen de ${figurita.name}`} />
                                        </div>
                                        <div className='name'>{figurita.name}</div>
                                        <div className='number'>{figurita.number}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </WrappedStyled>
            
            {showRankingModal && (
                <RankingModalOverlay onClick={handleCloseRanking}>
                    <RankingModalContent onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Ranking</h2>
                            <button className="close-button" onClick={handleCloseRanking}>
                                <IoClose />
                            </button>
                        </div>
                        
                        {/* <div className="ranking-list">
                            <p>
                                La información estará disponible en cuanto se defina y se publique la lista oficial de la Selección Argentina. De esta forma, sabrás cuántos aciertos tuviste y tu posición en la tabla.
                            </p>
                        </div> */}

                        {isLoadingRanking ? (
                            <div className="loading">
                                <CircularProgress size={40} style={{ color: '#252e7c' }} />
                                <p>Cargando ranking...</p>
                            </div>
                        ) : rankingData ? (
                            <>
                                <div className="user-stats">
                                    <div className="stat">
                                        <div className="label">Tu Posición</div>
                                        <div className="value">{rankingData.usuario?.posicion || '-'}</div>
                                    </div>
                                    <div className="stat">
                                        <div className="label">Tus Puntos</div>
                                        <div className="value">{rankingData.usuario?.puntaje || '0'}</div>
                                    </div>
                                </div>
                                
                                <div className="ranking-list">
                                    {rankingData.ranking?.map((item, index) => (
                                        <div 
                                            key={item.uid || index}
                                            className={`ranking-item ${
                                                item.uid === uid ? 'current-user' : ''
                                            }`}
                                        >
                                            {/* <div className="position">{item.posicion}</div> */}
                                            <div className="position">1</div>
                                            <div className="name">{item.nombre} {item.apellido}</div>
                                            <div className="points">{item.puntaje}</div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="loading">
                                <p>No se pudo cargar el ranking</p>
                            </div>
                        )}
                    </RankingModalContent>
                </RankingModalOverlay>
            )}
            
            {showMecanicaModal && (
                <MecanicaModalOverlay onClick={handleCloseMecanica}>
                    <MecanicaModalContent onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Mecánica</h2>
                            <button className="close-button" onClick={handleCloseMecanica}>
                                <IoClose />
                            </button>
                        </div>
                        
                        <div className="modal-body">
                            <h3>ACERTÁ LA LISTA Y GANÁ</h3>

     <p>                      
Del 13 al 25 de mayo vas a poder armar tu lista seleccionando los 26 jugadores que creas que
integrarán la convocatoria final rumbo al Mundial 2026.<br/>
Cada jugador acertado sumará 1 punto para el ranking final.<br/><br/>
Durante ese período podrás agregar o deseleccionar jugadores antes de guardar tu lista. Una
vez enviada, tu selección quedará registrada para participar del desafío.<br/><br/>
Cuando se conozca la convocatoria oficial definida por Scaloni, se contabilizarán los aciertos
de cada participante y se generará un ranking con quienes hayan sumado más puntos.<br/><br/>
Los 30 participantes mejor posicionados ganarán merchandising oficial de la Selección
Argentina.<br/><br/>
En caso de empate en alguna de las posiciones ganadoras, se realizará un sorteo
para definir los puestos finales.<br/><br/>
<strong>¡Prepará tu mirada futbolera y demostrá tus conocimientos para armar la Scaloneta final!</strong>
</p> 

                            {/* <p>
                                Seleccioná los 26 jugadores que creés que formarán parte de la lista oficial 
                                de la Selección Argentina para el Mundial 2026.
                            </p>
                            
                            <h3>Instrucciones</h3>
                            <ul>
                                <li>Podés seleccionar hasta 26 figuritas haciendo clic sobre ellas</li>
                                <li>Para deseleccionar una figurita, simplemente volvé a hacer clic sobre ella</li>
                                <li>Podés guardar tu selección en cualquier momento con el botón "Guardar Cambios"</li>
                                <li>Una vez que tengas tus 26 jugadores seleccionados, podés enviar tu lista final</li>
                                <li>Tenés tiempo hasta el 25 de mayo inclusive para enviar tu lista</li>
                            </ul>
                            
                            <h3>Puntuación</h3>
                            <p>
                                Cuando se anuncie la lista oficial del Mundial 2026, sumarás puntos por cada 
                                jugador que hayas acertado en tu selección.
                            </p>
                            
                            <p>
                                <strong>¡Elegí bien y competí por los primeros puestos del ranking!</strong>
                            </p> */}
                        </div>
                    </MecanicaModalContent>
                </MecanicaModalOverlay>
            )}
            
            {showEventEndedModal && (
                <EventEndedModalOverlay>
                    <EventEndedModalContent>
                        <div className="icon-container">
                            <TbStarsFilled />
                        </div>
                        <h2>YA SE DEFINIÓ LA SCALONETA FINAL</h2>
                        <p>
                            Tenemos 58 participantes en el podio con 25 de 26 aciertos. Próximamente realizaremos el sorteo para conocer a los 30 ganadores finales.
                        </p>
                        <button className="close-button" onClick={handleCloseEventEnded}>
                            Entendido
                        </button>
                    </EventEndedModalContent>
                </EventEndedModalOverlay>
            )}
        </>
    );
};

export default ListaMundialContainer;